<template>
  <div class="policies-create">
    <!-- Coverage types -->
    <SelectCoverages v-model:coverage-type-ids="coverageTypeIds" :columns="4" />

    <div class="policies-create__divider"></div>

    <!-- Submit btn -->
    <Btn class="policies-create__btn" @click="onComplete">Complete</Btn>
  </div>
</template>

<script setup lang="ts">
import { ref, Ref } from 'vue';
import { useRouter } from 'vue-router';
import { toast } from '@/js/Helpers/Alert';
import Btn from '@/js/Components/Btn.vue';
import Loader from '@/js/Helpers/Loader';
import PolicyApi from '@/js/Api/Policy';
import SelectCoverages from '@/js/Common/Form/SelectCoverages.vue';

const props = defineProps<{
  clientId: number;
}>();

const router = useRouter();

const coverageTypeIds: Ref<number[]> = ref([]);

const onComplete = () => {
  if (!coverageTypeIds.value.length) return;

  Loader.start();
  PolicyApi.create({ clientId: props.clientId, coverageTypeIds: coverageTypeIds.value })
    .then(({ data: policy }) => {
      router.push({ name: 'ClientPolicyMain', params: { clientId: props.clientId, policyId: policy.id } });
    })
    .catch(() => {
      toast({ title: 'An error has occurred while creating a policy.', icon: 'error' });
    })
    .finally(() => {
      Loader.end();
    });
};
</script>

<style lang="scss">
.policies-create {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &__btn {
    align-self: flex-end;
  }

  &__divider {
    width: 100%;
    height: 1px;
    background-color: color('gray', 3);
    margin: 1em 0;
  }

  // Coverage types
  .select-coverages {
    font-size: 1.1em;
    &__submit-container {
      display: none;
    }
  }
}
</style>
